<script setup>
import {computed, watch} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import PageEditorContentPanelTabBtn from "./PageEditorContentPanelTabBtn.vue"
import PageEditorSiteTree from "./PageEditorSiteTree.vue"
import PageEditorContentNav from "./PageEditorContentNav.vue"
import {useAppStore} from '@/stores/appStore'
import {usePageEditorStore} from '@/stores/pageEditor'
import {useSiteTreeStore} from '@/stores/siteTree'

const tabs = [
    {name: 'Site tree', icon: 'bi-diagram-3'},
    {name: 'Content', icon: 'bi-list'}
]

const route = useRoute()
const router = useRouter()
const appStore = useAppStore()
const pageEditorStore = usePageEditorStore()

const activeTab = computed(() => pageEditorStore.leftSidebarActiveTab)
const siteTreeId = computed(() => pageEditorStore.siteTreeId)
const pageId = computed(() => pageEditorStore.pageId || appStore.settings.homePage)
const activeSectionId = computed(() => pageEditorStore.activeSectionId)
const activeContentAreaName = computed(() => pageEditorStore.activeContentAreaName)
const activePageContentId = computed(() => pageEditorStore.activePageContentId)

const siteTreeStore = useSiteTreeStore(siteTreeId.value)

const setPageId = () => {
    siteTreeStore.setPageId(pageId.value)
    siteTreeStore.setExpandedPageIds(pageId.value)
}

if (activeSectionId.value || activeContentAreaName.value || activePageContentId.value) {
    pageEditorStore.leftSidebarActiveTab = 'Content'
}

siteTreeStore.init({
    onPageSelect: (selectedId) => {
        if (
            pageEditorStore.pageId !== selectedId ||
            route.query.area ||
            route.query.id
        ) {
            siteTreeStore.setSelectedPageId(selectedId)
            router.push({name: 'pageEditor', params: {pageId: selectedId}})
        }
    }
})

setPageId()

watch(pageId, () => {
    setPageId()
})
</script>

<template>
    <aside class="border-end overflow-y-scroll" :class="{'open': activeTab, 'closed': !activeTab}">
        <section class="d-flex h-100">
            <div class="d-flex flex-column" style="margin-top: -1px">
                <PageEditorContentPanelTabBtn v-for="tab in tabs" :key="tab.name" :icon-class="tab.icon"
                                              :tab-name="tab.name" :active-tab-prop-name="'leftSidebarActiveTab'"
                                              :border-class-name="'border-end'"/>

                <div class="flex-fill bg-body-tertiary border-end"></div>
            </div>

            <div v-if="activeTab" class="flex-fill overflow-scroll">
                <template v-if="activeTab === 'Site tree'">
                    <PageEditorSiteTree/>
                </template>

                <PageEditorContentNav v-if="activeTab === 'Content'"/>
            </div>
        </section>
    </aside>
</template>

<style scoped>
.closed {
    flex: 0 0 32px
}

.open {
    flex: 0 0 250px
}
</style>